"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageService = void 0;
const rxjs_1 = require("rxjs");
const root_scope_service_1 = require("./upgraded-providers/wrappers/root-scope.service");
const root_scope_settings_1 = require("@core/settings/root-scope.settings");
const language_settings_1 = require("@core/settings/language.settings");
const i0 = __importStar(require("@angular/core"));
const i1 = __importStar(require("./upgraded-providers/wrappers/root-scope.service"));
class LanguageService {
    constructor(_rootScopeService) {
        this._rootScopeService = _rootScopeService;
        this.rootScopeChanges$ = new rxjs_1.Subscription();
        this._rootScopeChanges = {};
        this._language = language_settings_1.SUPPORTED_LANGUAGES.en;
        this.language$ = new rxjs_1.BehaviorSubject(this._language);
        this._rootScopeService.detectScopeChanges(root_scope_settings_1.ROOT_SCOPE_VARIABLES.LANGUAGE.SELECTED_LANGUAGE);
        //subscribe to rootScopeSubject to detect desired changes
        this.rootScopeChanges$ = this._rootScopeService.rootScopeObservable
            .subscribe(rootScope => {
            this._rootScopeChanges = rootScope;
            if (rootScope[root_scope_settings_1.ROOT_SCOPE_VARIABLES.LANGUAGE.SELECTED_LANGUAGE]) {
                this.onSetLanguage(rootScope[root_scope_settings_1.ROOT_SCOPE_VARIABLES.LANGUAGE.SELECTED_LANGUAGE]);
            }
        });
    }
    onSetLanguage(selectedLanguage) {
        const supportedLanguage = language_settings_1.SUPPORTED_LANGUAGES[selectedLanguage];
        if (supportedLanguage) {
            this._language = supportedLanguage;
            this.language$.next(supportedLanguage);
        }
    }
}
exports.LanguageService = LanguageService;
LanguageService.ɵfac = function LanguageService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LanguageService)(i0.ɵɵinject(i1.RootScopeService)); };
LanguageService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LanguageService, factory: LanguageService.ɵfac, providedIn: 'root' });
